import {
  getStorage,
  listAll,
  ref,
  getDownloadURL,
  getMetadata
} from 'firebase/storage';
import { existsWithLength } from '@aldridge/aldg-helpers';
import getURL from './getURL';

const getAttachments = (mounted, setLoading, setAllFiles, folder) =>
  new Promise((resolve) => {
    const storage = getStorage();
    setLoading(true);
    setAllFiles([]);

    const processFile = async (itemRef) => {
      try {
        const meta = await getMetadata(itemRef);
        const url = await getDownloadURL(itemRef);

        // Check if it's an image file
        const isImage =
          meta.contentType && meta.contentType.startsWith('image/');

        const fileObj = {
          downloadURL: url,
          url: getURL(url, meta.contentType),
          type: meta.contentType,
          name: itemRef.name,
          uploadedBy: meta.customMetadata?.uploadedBy,
          uploadedDate: meta.customMetadata?.uploadedDate,
          LinkTo: meta.customMetadata?.LinkTo,
          NeedsDriveViewer: !(
            ['application/pdf', 'text/plain'].includes(meta.contentType) ||
            meta.contentType.indexOf('image/') > -1
          ),
          width: meta.width,
          height: meta.height,
          folder: itemRef.fullPath.split('/').slice(0, -1).join('/')
        };

        // For images, try to get base64 data
        if (isImage) {
          try {
            const response = await fetch(url);
            const blob = await response.blob();
            const reader = new FileReader();

            fileObj.base64 = await new Promise((resolveBase64) => {
              reader.onload = () => resolveBase64(reader.result.split(',')[1]); // Remove data URL prefix
              reader.readAsDataURL(blob);
            });
          } catch (error) {
            console.error(`Error getting base64 for ${itemRef.name}:`, error);
            fileObj.base64 = null;
          }
        }

        return fileObj;
      } catch (error) {
        console.error(`Error processing file ${itemRef.name}:`, error);
        return null;
      }
    };

    const processFolder = async (folderPath) => {
      try {
        const folderRef = ref(storage, folderPath);
        const res = await listAll(folderRef);

        if (existsWithLength(res.items)) {
          const filePromises = res.items.map(processFile);
          const files = await Promise.all(filePromises);
          return files.filter((file) => file !== null);
        }
        return [];
      } catch (error) {
        console.error(`Error processing folder ${folderPath}:`, error);
        return [];
      }
    };

    const getAllFiles = async () => {
      try {
        // Process files from base folder
        const baseFiles = await processFolder(folder);

        // Process files from Obstacles subfolder
        const obstacleFiles = await processFolder(`${folder}/Obstacles/`);

        // Combine and sort all files
        const allFiles = [...baseFiles, ...obstacleFiles]
          .filter(
            (obj, index, arr) =>
              arr.findIndex((item) => item.name === obj.name) === index
          )
          .sort((a, b) => {
            const dateA = a.uploadedDate || '';
            const dateB = b.uploadedDate || '';
            if (dateA > dateB) return -1;
            if (dateA < dateB) return 1;
            return 0;
          });

        if (mounted.current) {
          setAllFiles(allFiles);
          setLoading(false);
        }

        resolve(allFiles);
      } catch (error) {
        console.error('Error getting attachments:', error);
        if (mounted.current) {
          setLoading(false);
        }
        resolve([]);
      }
    };

    getAllFiles();
  });

export default getAttachments;
